import { render, staticRenderFns } from "./voiceMaterial.vue?vue&type=template&id=de204e46&"
import script from "./voiceMaterial.vue?vue&type=script&lang=ts&"
export * from "./voiceMaterial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports